<template lang="">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16.623 21"
  >
    <path
      id="shield_FILL0_wght300_GRAD0_opsz48"
      d="M13.3,23.8A10.692,10.692,0,0,1,7.342,19.49a12.358,12.358,0,0,1-2.355-7.328V5.9L13.3,2.8l8.311,3.1v6.261a12.358,12.358,0,0,1-2.355,7.328A10.692,10.692,0,0,1,13.3,23.8Zm0-1.33a9.654,9.654,0,0,0,5.084-3.879,11.089,11.089,0,0,0,1.981-6.427V6.788L13.3,4.128,6.234,6.788v5.375A11.089,11.089,0,0,0,8.214,18.59,9.654,9.654,0,0,0,13.3,22.468ZM13.3,13.3Z"
      transform="translate(-4.986 -2.799)"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
export default {
  props: {
    width: {
      type: Number,
      default: 16.623,
    },
    height: {
      type: Number,
      default: 21,
    },
  },
};
</script>
<style lang=""></style>
